import "./style.css";

export default class ReadingHeader {
  static selector = ".reading-header";

  constructor(block) {
    this.block = block;

    this.progressBar = this.block.querySelector(".reading-header__progress");
    this.content = document.querySelector(
      ".article, .publication, .specialism"
    );

    this.back = this.block.querySelector(".reading-header__back");
    this.back?.addEventListener("click", this.onBack);
  }

  updateProgress = () => {
    const halfWindow = window.innerHeight / 2;
    const articleOffsetBottom =
      this.content.offsetTop + this.content.clientHeight;
    const maxScroll =
      document.body.scrollHeight -
      (document.body.scrollHeight - articleOffsetBottom) -
      halfWindow;

    this.progressBar.style.backgroundSize =
      (window.pageYOffset / maxScroll) * 100 + "% 100%";
  };

  // Event handlers
  onBack = event => {
    history.back();
    event.preventDefault();
  };

  // Public
  onReady = () => {};
  onDestroy = () => {
    this.back?.removeEventListener("click", this.onBack);
  };
  onResize() {}

  onScroll() {
    if (this.progressBar) {
      this.updateProgress();
    }
  }
}
